import React, { Component } from 'react'
import { connect } from 'dva'
import BasicLayout from '../../components/BasicLayout'
import './styles.less'
import { Input, Button, Form, Row, Col, message } from 'antd'

const { TextArea } = Input
const FormItem = Form.Item

const VALIDATION = {
  EN: {
    required: {
      name: 'Name is required.',
      email: 'Email address is required.',
      phone: 'Phone number is required.',
      company: 'Company name is required.',
      message: 'Your message is required.',
    },
    invalid: {
      name: 'Please enter a valid name.',
      email: 'Please enter a valid email address.',
      phone: 'Please enter a valid phone number.',
      company: 'Please enter a valid company name.',
      message: 'Please enter a valid message.',
    },
  },
  CN: {
    required: {
      name: '请输入姓名',
      email: '请输入邮箱地址',
      phone: '请输入手机号码',
      company: '请输入公司名称',
      message: '请输入您的留言',
    },
    invalid: {
      name: '请输入有效的姓名',
      email: '请输入有效的邮箱地址',
      phone: '请输入有效的手机号码',
      company: '请输入有效的公司名称',
      message: '请输入有效的留言',
    },
  },
}

class ContactUs extends Component {
  formRef = React.createRef()
  constructor(props) {
    super(props)
    this.state = {
      username: null,
      email: null,
      company: null,
      desc: null,
      phone: null,
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { customer } = this.props
    if (customer !== nextProps.customer && nextProps.customer) {
      const msg = nextProps.locale === 'EN'
        ? 'Thank you for contacting us. Our team will respond within 1–2 business days.'
        : '感谢您的留言，我们将在1-2个工作日内回复。'
      message.success(msg)
      this.formRef.current.resetFields()
      this.props.dispatch({ type: 'user/setState', payload: { customer: null } })
    }
  }

  onFinish = (payload) => {
    this.props.dispatch({
      type: 'user/apiPostCustomer',
      payload,
    })
  }

  handleResetForm = () => {
    this.formRef.current.resetFields()
  }

  render() {
    const { userInfo, locale } = this.props
    const isEN = locale === 'EN'
    const v = isEN ? VALIDATION.EN : VALIDATION.CN
    const namePattern = /^[\p{L}\s\-'.]+$/u
    const companyPattern = /^[\p{L}\p{N}\s\-.,&()]+$/u

    return (
      <BasicLayout selectedKeys={['/contactUs']}>
        <div className="contact_container">
          <div className="contact_us">
            <img className="img" src={require('../../assets/us/top.png')} alt="top" />
            <div className="title">{isEN ? 'Contact Us' : '联系我们'}</div>
            <div className="contact_subtitle">{isEN ? 'Get in touch with our team.' : '与我们的团队取得联系。'}</div>
          </div>
          <div className="contact_middle">
            <div className="divider"><img alt="img" src={require('../../assets/common/divider.png')} /></div>
            <div className="text">
              {isEN
                ? "We'd love to hear from you. Please complete the form below and our team will respond shortly."
                : '我们期待您的反馈。请填写下方表单，我们的团队将尽快回复。'}
            </div>
          </div>
          <div className="contact_map">
            <div className="info_card">
              <div className="info_line">
                {/* <img alt="icon" src={require('../../assets/icon/position.png')} /> */}
                <span>Silicon Valley Office<br />1999 S. Bascom Ave, Suite 700<br />Campbell, CA 95008<br />United States</span>
              </div>
              <div className="info_line"><img alt="icon" src={require('../../assets/icon/phoneNumber.png')} /><span>+1 408 354 0888</span></div>
              <div className="info_line"><img alt="icon" src={require('../../assets/icon/email.png')} /><span>sales@nikopartners.com</span></div>
            </div>
          </div>
          <div className="contact_got">
            <div className="main">
              <div className="title">{isEN ? 'Contact Form' : '联系表单'}</div>
              <div className="divider"><img alt="img" src={require('../../assets/common/divider.png')} /></div>
              <Form ref={this.formRef} onFinish={this.onFinish} layout="vertical" className="contact_form">
                <Row gutter={24}>
                  <Col span={12}>
                    <FormItem
                      label={isEN ? 'Full Name' : '姓名'}
                      name="username"
                      rules={[
                        { required: true, message: v.required.name },
                        { pattern: namePattern, message: v.invalid.name },
                      ]}
                    >
                      <Input placeholder={isEN ? 'Full Name' : '姓名'} className="inline_input" />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem
                      label={isEN ? 'Email Address' : '邮箱地址'}
                      name="email"
                      rules={[
                        { required: true, message: v.required.email },
                        { type: 'email', message: v.invalid.email },
                      ]}
                    >
                      <Input placeholder={isEN ? 'Email Address' : '邮箱地址'} className="inline_input" />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem
                      label={isEN ? 'Phone Number' : '手机号码'}
                      name="phone"
                      rules={[
                        { required: true, message: v.required.phone },
                        { pattern: /^[\d\s\-+()]+$/, message: v.invalid.phone },
                      ]}
                    >
                      <Input placeholder={isEN ? 'Phone Number' : '手机号码'} className="inline_input" />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem
                      label={isEN ? 'Company Name' : '公司名称'}
                      name="company"
                      rules={[
                        { required: true, message: v.required.company },
                        { pattern: companyPattern, message: v.invalid.company },
                      ]}
                    >
                      <Input placeholder={isEN ? 'Company Name' : '公司名称'} className="inline_input" />
                    </FormItem>
                  </Col>
                  <Col span={24}>
                    <FormItem
                      label={isEN ? 'Your Message' : '您的留言'}
                      name="desc"
                      rules={[
                        { required: true, message: v.required.message },
                        { min: 2, message: v.invalid.message },
                      ]}
                    >
                      <TextArea
                        rows={6}
                        placeholder={isEN ? 'Your Message' : '您的留言'}
                      />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <div className="reset"><span onClick={this.handleResetForm}>{isEN ? 'Clear Form' : '清空表单'}</span></div>
                  </Col>
                  <Col span={12}>
                    <FormItem style={{ textAlign: 'right' }}>
                      <Button htmlType="submit" disabled={!(userInfo && userInfo.id)}>{isEN ? 'Submit Form' : '发送给我们'}</Button>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </BasicLayout>
    )
  }
}

export default connect(({ user }) => ({
  customer: user.customer,
  userInfo: user.userInfo,
  locale: user.locale,
}))(ContactUs)
